export function button() {
  function moveArrow() {
    $('.js-button.-arrow').css('--button-arrow-right', '-42px');
  }

  function backArrow() {
    $('.js-button.-arrow').css('--button-arrow-right', '-34px');
  }

  $('.js-button.-arrow').on({
    mouseenter: moveArrow,
    mouseleave: backArrow,
  });
}
